var render = function render(_c,_vm){return _c('div',{staticClass:"filters-list-section"},[_c('div',{staticClass:"filters-list-section__wrapper"},[_c('div',{staticClass:"filters-list-section__title"},[_vm._t("title")],2),_vm._v(" "),_vm._t("content")],2),_vm._v(" "),_c('div',{staticClass:"filters-list-section__line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }